module.exports = __webpack_public_path__ + "static/img/风机盘管.5bd89e75.png";